import { IonCard, IonCardContent, IonCol, IonItem, IonRow, IonText } from "@ionic/react"
import InputItem from "../../../components/input/InputItem"
import { cardOutline } from "ionicons/icons"
import CheckBoxItem from "../../../components/checkbox/CheckBoxItem"

import './Section4.css'
import ActionButton from "../../../components/button/ActionButton"
import { useState } from "react"
import { DataProvider } from "../../../library/DataProvider"
import SlideContent from "../../../components/slide-content/SlideContent"

interface Props {
    formLoading: boolean,
    formProvider: any,
    cardStatus: string,
    avoidPay: boolean,
    doneClick: any
}

const Section4: React.FC<Props> = (props) => {
    const [action, setAction] = useState("");
    let minAmount = Number(50000).toPrice();

    return <SlideContent type="navbar" class="section4">
        <IonCard>
            <IonCardContent>
                <IonRow>
                    <IonCol>
                        <IonText className="head-text ion-margin-bottom">اینجانب متعهد می شوم ماهانه مبلغ زیر را برای کمک به اهداف انجام پرداخت نمایم.</IonText>

                        <InputItem name="aid_amount" type="number" label={`مبلغ تعهد ماهانه (حداقل ${minAmount})`} icon={cardOutline} provider={props.formProvider} />

                        <IonText className="head-text">اینجانب رضایت و آمادگی خود را برای مشارکت در پروژه های حفاظت از محیط زیست که از سوی انجمن نذرطیبعت اجرای می شود اعلام می دارم و تمام تلاش های خود را در حد توان چه به صورت مادی و چه به صورت غیرمادی همچون تامین امکانات مورد نیاز برای پروژه ها همچون ساخت آبشخور، تامین علوفه، تیمار حیات وحش و ... به کار می گیرم و با دریافت کارت حامی طبیعت متعهد می شوم حمایت از پروژه های انجمن نذرطبیعت را تا پایان تاریخ عضویت ادامه دهم.</IonText>

                        <CheckBoxItem name="aid_obligation" key="aid_obligation" label="موارد فوق را می پذیرم." provider={props.formProvider} />

                        <div className="note">
                            <IonText>هزینه صدور و ارسال کارت (چاپ کارت + هزینه ارسال)</IonText>
                            <h3>{window.initials?.messages.card_price_value}</h3>
                        </div>

                        <ActionButton color="blue" text="ذخیره موقت مشخصات" loading={props.formLoading && action == ''} click={() => { setAction(''); props.doneClick('') }} />

                        {(props.cardStatus == 'none' || props.cardStatus == '') && !props.avoidPay ? <ActionButton text="پرداخت و ارسال درخواست صدور کارت" loading={props.formLoading && action == 'pay'} click={() => { setAction('pay'); props.doneClick('pay') }} /> : null}
                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Section4